export const callReroutingDay = {
  id: 82,
  name: 'Call Rerouting - Day',
  defaultMax: 175,
};

export const callReroutingNight1 = {
  id: 83,
  name: 'Call Rerouting - Night1',
  defaultMax: 175,
};

export const callReroutingNight2 = {
  id: 84,
  name: 'Call Rerouting - Night2',
  defaultMax: 175,
};

export const callRerouting1stAlternative = {
  id: 86,
  name: 'Call Rerouting - 1st Alt.',
  defaultMax: 336,
};

export const callRerouting2ndAlternative = {
  id: 87,
  name: 'Call Rerouting - 2nd Alt.',
  defaultMax: 32,
};